import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import {
  useDataProvider,
  useNotify,
  useRefresh
} from 'react-admin';
import { StopCircle as StopIcon } from '@mui/icons-material';
import { useState } from 'react';

export const StopTimerButton = ({ record }: { record?: any }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isStopping, setIsStopping] = useState(false);

  const handleStopClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDialogOpen(true);
  };

  const handleConfirmStop = async () => {
    if (!record?.id) {
      notify('Cannot stop timer: Invalid time entry', { type: 'error' });
      return;
    }

    try {
      setIsStopping(true);
      const endedAt = new Date().toISOString();

      await dataProvider.update('timetracking/segments', {
        id: record.id,
        data: { endedAt },
        previousData: record,
      });

      notify('Timer stopped successfully', { type: 'success' });
      setDialogOpen(false);
      refresh();
    } catch (error: any) {
      notify(error.message || 'Failed to stop timer', { type: 'error' });
    } finally {
      setIsStopping(false);
    }
  };

  const handleCancel = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDialogOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={handleStopClick}
        size="small"
        disabled={isStopping}
      >
        <StopIcon fontSize="small" sx={{ color: 'error.main' }} />
      </IconButton>

      <Dialog
        open={dialogOpen}
        onClose={handleCancel}
        aria-labelledby="stop-timer-dialog-title"
        aria-describedby="stop-timer-dialog-description"
        onClick={(e) => e.stopPropagation()}
      >
        <DialogTitle id="stop-timer-dialog-title">
          Stop Timer
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="stop-timer-dialog-description">
            Are you sure you want to end the timer for this task?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} disabled={isStopping}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmStop}
            color="error"
            variant="contained"
            disabled={isStopping}
          >
            {isStopping ? 'Stopping...' : 'Stop Timer'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
